import { formatDateTime24 } from '../utils/formatTime24';

export const ESTADOS = {
  draft: { txt: 'Borrador', cls: 'text-gray-600 bg-gray-100' },
  active: { txt: 'Programado', cls: 'text-emerald-700 bg-emerald-50' },
  paused: { txt: 'Pausado', cls: 'text-amber-700 bg-amber-50' },
  finished: { txt: 'Enviado', cls: 'text-blue-700 bg-blue-50' },
};

export const proximo = (iso) => {
  if (!iso) return '';
  try {
    return formatDateTime24(iso, { dateOptions: { weekday: 'short', day: 'numeric', month: 'short' } });
  } catch (e) { return ''; }
};

/** Vista previa: los links del mail se abren en otra pestaña (como en Gmail), no dentro del recuadro. */
export const enPestana = (html) => String(html || '').replace('<head>', '<head><base target="_blank">');
